import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureFirstTouch } from "@/lib/firstTouch";
import { refreshGrowthMode } from "@/lib/growthMode";

// Signup-source attribution (first visit only) + growth-free-mode flag. Both best-effort.
captureFirstTouch();
refreshGrowthMode();

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Three mount paths:
// 1. data-ssg="1" — the route was statically generated by scripts/ssg.js (real
//    HTML for crawlers, but hand-built so it does NOT match React's tree). Clear
//    it and mount fresh to avoid hydration mismatches.
// 2. has children (no marker) — a react-snap prerender; hydrate it.
// 3. empty — normal client render.
if (rootElement.getAttribute('data-ssg') === '1') {
  rootElement.innerHTML = '';
  ReactDOM.createRoot(rootElement).render(app);
} else if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
